import React from "react";
import "./Footer.css";
import { Typography, Box } from "@mui/material";

function Footer() {
  return (
    <footer className="App-footer">
      {/* Container untuk logo dan teks yang sejajar */}
      <Box className="footer-header">
        <img 
          src="/images/logo-sumbawa-barat.png" 
          alt="Logo Sumbawa Barat" 
          className="footer-logo" 
        />
        <Typography 
          variant="body2" 
          className="footer-text"
        >
          ©{new Date().getFullYear()} Dinas Perumahan dan Permukiman Kabupaten Sumbawa Barat.
        </Typography>
      </Box>

      {/* Versi SI-DALIMAH di bawah */}
      <Typography
        variant="caption"
        className="footer-version"
      >
        SI-DALIMAH v0.2.0
      </Typography>
    </footer>
  );
}

export default Footer;